import { v4 as uuidV4 } from "uuid";
import { createServiceBuilder } from "./lib";
import { injectedDialogSlice } from "./reducer";
import { createSelector } from "@reduxjs/toolkit";
const { actions, selectors } = injectedDialogSlice;
export const DialogServiceBuilder = createServiceBuilder({
    name: 'DialogService',
    api: () => {
        let dialogSingleton;
        const newDialogModel = ({ id, prompt, onClose }) => {
            const { promise, resolve, } = Promise.withResolvers();
            return {
                id,
                prompt,
                promise,
                confirm: () => {
                    onClose();
                    resolve(true);
                },
                cancel: () => {
                    onClose();
                    resolve(false);
                },
            };
        };
        const closeDialog = () => (dispatch) => {
            dialogSingleton = undefined;
            dispatch(actions.closeDialog());
        };
        const createDialog = (prompt) => (dispatch) => {
            const id = uuidV4();
            dialogSingleton = newDialogModel({ id, prompt, onClose: () => dispatch(closeDialog()) });
            dispatch(actions.openDialog({ id, prompt }));
            return dialogSingleton.promise;
        };
        return {
            createDialog,
            closeDialog,
            getDialog: createSelector(selectors.getDialog, () => dialogSingleton),
            isDialogOpened: createSelector(selectors.getDialog, () => dialogSingleton, () => Boolean(dialogSingleton)),
        };
    },
});
//# sourceMappingURL=DialogService.js.map